import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Signup from '../views/Signup.vue'
import Login from '../views/Login.vue'
import LoginGoogle from '../views/LoginGoogle.vue'
import LoginGoogleInit from '../views/LoginGoogleInit.vue'
import store from '../store/index'
import Site from '../views/Site.vue'
import Dashboard from '../views/Dashboard.vue'
import Onboarding from '../views/Onboarding.vue'
import Onboarding2 from '../views/Onboarding2.vue'
import Onboarding3 from '../views/Onboarding3.vue'
import Kiosks from '../views/Kiosks'
import Devices from '../views/Devices'
import Kiosk from '../views/Kiosk.vue'
import KioskBranded from '../views/KioskBranded.vue'
import KioskPublic from '../views/KioskPublic.vue'
import KioskDemo from '../views/KioskDemo.vue'
import Status from '../views/Status.vue'
import KitOnboarding from '../views/kitOnboarding/KitOnboarding'
import DeviceOnboarding from '../views/kitOnboarding/DeviceOnboarding'
import CommanderLogin from '../views/CommanderLogin'
import AcceptInvite from '../views/AcceptInvite'
import Settings from '../views/Settings'
import Reports from '../views/Reports'
import HeatMap from '../views/HeatMaps'
import PointExplorer from '../views/PointExplorer'
import VirtualEdge from '../views/VirtualEdge'
import DesignPalette from '../views/DesignPalette'
// Site 

Vue.use(VueRouter)

  const routes = [
  {
    path: '/status/cps',
    name: 'Status',
    component: Status,
    meta: { 
      requiresAuth: false 
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/projects/:projectId',
    name: 'Project',
    component: Home,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/projects/:projectId/sites/:siteId',
    name: 'Site',
    component: Site,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/projects/:projectId/dashboards',
    name: 'Dashboard',
    component: Dashboard,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/projects/:projectId/dashboards/:dashboardId',
    name: 'DashboardDetail',
    component: Dashboard,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/projects/:projectId/pointexplorer',
    name: 'PointExplorer',
    component: PointExplorer,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/projects/:projectId/virtualedge',
    name: 'VirtualEdge',
    component: VirtualEdge,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/projects/:projectId/aichat',
    name: 'AiChat',
    component: () => import(/* webpackChunkName: "aichat" */ '../views/AiChat.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/projects/:projectId/library',
    name: 'Library',
    component: () => import(/* webpackChunkName: "library" */ '../views/Library.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/projects/:projectId/devices',
    name: 'Devices',
    component: Devices,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/design-palette',
    name: 'DesignPalette',
    component: DesignPalette,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/projects/:projectId/sites/:siteId/floors',
    name: "FloorPlan",
    component: () => import(/* webpackChunkName: "floorplan" */ '../views/FloorPlan.vue'),
    meta: { 
        requiresAuth: true
    }
  },
  {
    path: '/projects/:projectId/sites/:siteId/heatmap',
    name: "Heatmap",
    component: () => import(/* webpackChunkName: "heatmap" */ '../views/HeatMaps.vue'),
    meta: {
        requiresAuth: true
    }
  },
  {
    path: "/projects/:projectId/sites/:siteId/alerts",
    name: "AlertsPage",
    component: () => import(/* webpackChunkName: "alerts" */ '../views/AlertsPage.vue'),
    meta: {
        requiresAuth: true
    }
  },
  {
    path: '/sites',
    // name: 'Site',
    component: Site,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/projects/:projectId/sites/:siteId/zones/:zoneId',
    name: 'Zone',
    component: Site,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { 
      requiresAuth: false
    }
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: Signup,
    meta: { 
      requiresAuth: false
    }
  },
  {
    path: '/acceptinvite',
    name: 'AcceptInvite',
    component: AcceptInvite,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/login/google',
    name: 'Google Login',
    component: LoginGoogle,
    meta: { 
      requiresAuth: false
    }
  },
  {
    path: '/login/cps',
    name: 'Google Login Init',
    component: LoginGoogleInit,
    meta: { 
      requiresAuth: false
    }
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: Onboarding,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/onboarding2',
    name: 'Onboarding2',
    component: Onboarding2,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/onboarding3',
    name: 'Onboarding3',
    component: Onboarding3,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/kiosk',
    name: 'Kiosk',
    component: Kiosk,
    meta: {
      specialAuth: true // Special Auth is for shareable kiosk where if a kiosk is included it bypasses logged in state provided it has a kiosk id
    }
  },
  {
    path: '/kioskbranded',
    name: 'Kiosk Branded',
    component: KioskBranded,
    meta: {
      specialAuth: true,
    }
  },
  {
    path: '/kiosks/:id',
    name: "Kiosk Public",
    component: KioskPublic,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/kiosks',
    name: "Kiosks",
    component: Kiosks,
    meta: {
      requiresAuth: true 
    }
  },
  {
    path: '/devices',
    name: 'DevicesLegacy',
    component: Devices,
    meta: {
      requiresAuth: true 
    }
  },
  {
    path: '/kioskdemo',
    name: 'Kiosk Demo',
    component: KioskDemo,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/konboarding/:id',
    name: 'Kit Onboarding',
    component: KitOnboarding,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/do/:id',
    name: 'Device Onboarding',
    component: DeviceOnboarding,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/commanderLogin',
    name: 'CommanderLogin',
    component: CommanderLogin,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      requiresAuth: true
    }
  },
  {
      path: "/projects/:projectId/sites/:siteId/reports",
      name: "Reports",
      meta: {
          requiresAuth: true
      },
      component: Reports
  },
  {
    path: '/projects/:projectId/sites/:siteId/schedules',
    meta: {
        requiresAuth: true
    },
    name: "SchedulesPage",
    component: () => import(/* webpackChunkName: "schedules" */ '../views/SchedulesPage.vue'),
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
});


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next({ name: 'Login', query: { from: to.fullPath } });
      return;
    }
    if (to.matched.some(record => record.meta.requiresAdmin)) {
      const user = store.state.user;
      const role = user && (user.role || (user.attributes && user.attributes.role));
      // User is not in the store yet on webpack refresh; let the page wait.
      if (role && role !== 'admin' && role !== 'superAdmin') {
        next({ path: '/' });
        return;
      }
    }
    // Site-only screens with no site in the URL: pick the first site the user can access.
    if (to.name === 'Kiosks' && !to.query.siteId) {
      store.dispatch('getSites').then(function(sites) {
        const first = store.getters.firstAccessibleSite || (sites && sites[0]) || null;
        const firstId = first ? (first.objectId || first.id) : null;
        if (firstId) {
          next({ path: to.path, query: Object.assign({}, to.query, { siteId: firstId }), replace: true });
        } else {
          next();
        }
      }).catch(function() {
        next();
      });
      return;
    }
    next();
    return;
  }

  if (to.matched.some(record => record.meta.specialAuth)) {
    if (store.getters.isLoggedIn) {
      next();
    } else if (to.query.kioskId) {
      next();
    } else {
      next({ name: 'Login', query: { from: to.fullPath } });
    }
    return;
  }

  next();
})

export default router